import { CDNImage } from '../Elements/Image';
import './BloodlineAura.css';

export function BloodlineAura({ id }: { id?: number | string | null }) {
  const eyeId = typeof id === 'string' && /^\d+$/.test(id) ? Number(id) : id;
  if (typeof eyeId !== 'number' || !Number.isSafeInteger(eyeId) || eyeId < 1) return null;
  return (
    <div className="bloodline-aura" aria-hidden="true">
      <CDNImage className="bloodline-aura__eye" src={`icons/bloodlines/bg/${eyeId}.png`} alt="" draggable={false} />
    </div>
  );
}
